// Discovery

/**
 * Information received from ORS about the a given input type and the
 * actions that can be applied to it.
 */

// Execution

export var ActionOperationStatus = /*#__PURE__*/function (ActionOperationStatus) {
  ActionOperationStatus["SUCCESS"] = "SUCCESS";
  ActionOperationStatus["FAILURE"] = "FAILURE";
  return ActionOperationStatus;
}({});

/**
 * The response shape from /gateway/api/object-resolver/actions/execute
 * T could be Icon or Status for example.
 */

// Errors